import { createSlice } from '@reduxjs/toolkit';

// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  chosenDistributorID: '',
  chosenDistributorName: '',
  holdDistributorID: '',
  holdDistributorName: '',
  listProducts: [],
  isClickNavbar: false,
  isEditConsignmentStockReturnable: false,
  stockReturnableID: '',
  chosenConsignmentSKUOrderID: [],
  chosenConsignmentSKUOrderSerial: [],

  // Tambahan 14-10-2026
  totalPackage: 0,
  packageImages: [],
  packageImagesName: [],
  shippingType: '',
  trackingCourier: '',
  trackingCourierID: '',
  trackingNumber: '',
}

const slice = createSlice({
  name: 'consignmentStockReturnable',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    setChosenDistributorID(state, action) {
      state.isLoading = false;
      state.chosenDistributorID = action.payload
    },

    setChosenDistributorName(state, action) {
      state.isLoading = false;
      state.chosenDistributorName = action.payload
    },

    setHoldDistributorID(state, action) {
      state.isLoading = false;
      state.holdDistributorID = action.payload
    },

    setHoldDistributorName(state, action) {
      state.isLoading = false;
      state.holdDistributorName = action.payload
    },

    setListProducts(state, action) {
      state.isLoading = false;
      state.listProducts = action.payload
    },

    setIsClickNavbar(state, action) {
      state.isLoading = false;
      state.isClickNavbar = action.payload
    },

    setIsEditConsignmentStockReturnable(state, action) {
      state.isLoading = false;
      state.isEditConsignmentStockReturnable = action.payload
    },

    setStockReturnableID(state, action) {
      state.isLoading = false;
      state.stockReturnableID = action.payload
    },

    setChosenConsignmentSKUOrderID(state, action) {
      state.isLoading = false;
      state.chosenConsignmentSKUOrderID = action.payload
    },

    setChosenConsignmentSKUOrderSerial(state, action) {
      state.isLoading = false;
      state.chosenConsignmentSKUOrderSerial = action.payload
    },

    setTotalPackage(state, action) {
      state.isLoading = false;
      state.totalPackage = action.payload;
    },

    setPackageImages(state, action) {
      state.isLoading = false;
      state.packageImages = action.payload;
    },

    setPackageImagesName(state, action) {
      state.isLoading = false;
      state.packageImagesName = action.payload;
    },

    setShippingType(state, action) {
      state.isLoading = false;
      state.shippingType = action.payload;
    },

    setTrackingCourier(state, action) {
      state.isLoading = false;
      state.trackingCourier = action.payload;
    },

    setTrackingCourierID(state, action) {
      state.isLoading = false;
      state.trackingCourierID = action.payload;
    },

    setTrackingNumber(state, action) {
      state.isLoading = false;
      state.trackingNumber = action.payload;
    },

    resetConsignmentStockReturnable(state) {
      state.chosenDistributorID = ''
      state.chosenDistributorName = ''
      state.holdDistributorID = ''
      state.holdDistributorName = ''
      state.listProducts = []
      state.isClickNavbar = false
      state.isEditConsignmentStockReturnable = false
      state.stockReturnableID = ''
      state.chosenConsignmentSKUOrderID = ''
      state.chosenConsignmentSKUOrderSerial = ''
      state.totalPackage = 0
      state.packageImages = []
      state.packageImagesName = []
      state.shippingType = ''
      state.trackingCourier = ''
      state.trackingCourierID = ''
      state.trackingNumber = ''
    }
  }
})

// Reducer
export default slice.reducer;

// Actions
export const {
} = slice.actions;


// ----------------------------------------------------------------------
export function setChosenDistributorID(value) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading())
    try {
      dispatch(slice.actions.setChosenDistributorID(value))
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.hasError(error))
    }
  }
}

export function setChosenDistributorName(value) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading())
    try {
      dispatch(slice.actions.setChosenDistributorName(value))
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.hasError(error))
    }
  }
}

export function setHoldDistributorID(value) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading())
    try {
      dispatch(slice.actions.setHoldDistributorID(value))
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.hasError(error))
    }
  }
}

export function setHoldDistributorName(value) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading())
    try {
      dispatch(slice.actions.setHoldDistributorName(value))
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.hasError(error))
    }
  }
}

export function setListProducts(value) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading())
    try {
      dispatch(slice.actions.setListProducts(value))
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.hasError(error))
    }
  }
}

export function setIsClickNavbar(value) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading())
    try {
      dispatch(slice.actions.setIsClickNavbar(value))
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.hasError(error))
    }
  }
}

export function setIsEditConsignmentStockReturnable(value) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading())
    try {
      dispatch(slice.actions.setIsEditConsignmentStockReturnable(value))
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.hasError(error))
    }
  }
}

export function setStockReturnableID(value) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading())
    try {
      dispatch(slice.actions.setStockReturnableID(value))
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.hasError(error))
    }
  }
}

export function setChosenConsignmentSKUOrderID(value) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading())
    try {
      dispatch(slice.actions.setChosenConsignmentSKUOrderID(value))
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.hasError(error))
    }
  }
}

export function setChosenConsignmentSKUOrderSerial(value) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading())
    try {
      dispatch(slice.actions.setChosenConsignmentSKUOrderSerial(value))
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.hasError(error))
    }
  }
}

export function setTotalPackage(value) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading())
    try {
      dispatch(slice.actions.setTotalPackage(value))
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.hasError(error))
    }
  }
}

export function setPackageImages(value) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading())
    try {
      dispatch(slice.actions.setPackageImages(value))
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.hasError(error))
    }
  }
}

export function setPackageImagesName(value) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading())
    try {
      dispatch(slice.actions.setPackageImagesName(value))
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.hasError(error))
    }
  }
}

export function setShippingType(value) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading())
    try {
      dispatch(slice.actions.setShippingType(value))
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.hasError(error))
    }
  }
}

export function setTrackingCourier(value) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading())
    try {
      dispatch(slice.actions.setTrackingCourier(value))
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.hasError(error))
    }
  }
}

export function setTrackingCourierID(value) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading())
    try {
      dispatch(slice.actions.setTrackingCourierID(value))
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.hasError(error))
    }
  }
}

export function setTrackingNumber(value) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading())
    try {
      dispatch(slice.actions.setTrackingNumber(value))
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.hasError(error))
    }
  }
}

export function resetConsignmentStockReturnable() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading())
    try {
      dispatch(slice.actions.resetConsignmentStockReturnable())
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.hasError(error))
    }
  }
}